module.exports = __webpack_public_path__ + "static/media/Updating.ab3b02c2.svg";